import { searchInputStyles } from "@insite/content-library/Widgets/Header/HeaderSearchInput";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

searchInputStyles.searchInputStyles = {
    input: {
        cssOverrides: {
            formInputWrapper: css`
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                margin-top: 1px !important;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            `,
        },
    },
    autocompleteWrapper: {
        css: css`
            display: flex;
            flex-direction: row-reverse;
            flex-wrap: wrap;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-direction: column;
                            max-height: 400px;
                            overflow: auto;
                            flex-wrap: nowrap;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    autocompleteColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 50%;
            flex: 1;
            padding: 0 20px 15px 20px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    popoverWrapper: {
        css: css`
            position: relative;
        `,
    },
    popoverContentBody: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100% !important;
                            right: 0 !important;
                        `,
                        css`
                            width: 100% !important;
                            right: 0 !important;
                        `,
                        css`
                            width: 100% !important;
                            right: 0 !important;
                        `,
                        css`
                            position: absolute !important;
                            top: 100% !important;
                            left: 0 !important;
                            max-height: initial !important;
                            width: 640px !important;
                        `,
                        css`
                            position: absolute !important;
                            top: 100% !important;
                            left: 0 !important;
                            max-height: initial !important;
                            width: 640px !important;
                        `,
                    ],
                    "min",
                );
            }}
        `,
    },
};
